"use client";

import { useCallback, useRef } from "react";
import { Button } from "@/components/ui/button";

interface CalComProps {
  triggerText?: string;
  triggerVariant?: "default" | "ghost" | "outline";
  triggerClassName?: string;
}

export default function CalCom({
  triggerText = "Book a Call",
  triggerVariant = "default",
  triggerClassName = "",
}: CalComProps) {
  const calInitializedRef = useRef(false);

  const initCal = useCallback(async () => {
    if (calInitializedRef.current) {
      return;
    }
    const { getCalApi } = await import("@calcom/embed-react");
    const cal = await getCalApi();
    cal("ui", {
      styles: { branding: { brandColor: "bg-coffee" } },
      hideEventTypeDetails: false,
    });
    calInitializedRef.current = true;
  }, []);

  return (
    <Button 
      variant={triggerVariant} 
      className={triggerClassName}
      data-cal-link="carlaheywood/15min"
      data-cal-config='{"layout":"month_view"}'
      aria-label={triggerText || "Book a call"}
      onMouseEnter={initCal}
      onFocus={initCal}
      onTouchStart={initCal}
      onClick={() => void initCal()}
    >
      {triggerText}
    </Button>
  );
}
